import { useTranslation } from 'react-i18next';

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  ImagePreviewDialog,
} from '@shared/ui';

export function ImagePreviewDialogShowcase() {
  const { t } = useTranslation();

  return (
    <Card data-testid="image-preview-dialog-showcase">
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.dialog.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.dialog.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <ImagePreviewDialog
          src="/images/team-dashboard-notification.jpg"
          alt=""
          title={t('uiLibrary.overlay.dialog.modalTitle')}
          closeLabel={t('common.close')}
          trigger={<Button variant="outline">{t('uiLibrary.overlay.dialog.trigger')}</Button>}
        />
      </CardContent>
    </Card>
  );
}
